export default {
    data: () => ({
        lendingKitColumns: [
            {
                label: "id",
                field: "id",
                sortable: true,
                required: true
            }, {
                label: "stock status",
                field: "stock_status.description",
                required: true,
                sortable: true
            }, {
                label: "lending point",
                field: "lending_point.description",
                required: true
            }, {
                label: "product model",
                field: "product_model.description",
                sortable: true,
                required: true
            }, {
                label: "product color",
                field: "product_color.description",
                sortable: true,
                required: true
            },
            {
                label: "codentify",
                field: "codentify",
                sortable: true
            }, {
                label: "child codentify 1",
                field: "child_codentify_1",
                sortable: true
            }, {
                label: "child codentify 2",
                field: "child_codentify_2",
                sortable: true
            },
            {
                label: "lendings",
                field: "uses",
                sortable: true,
                required: true
            },
            {
                label: "old codentify",
                field: "old_codentify",
                sortable: true,
            },
            {
                label: "enable lending creation",
                field: "enable_to_creation",
                sortable: true,
                required: true
            },
        ],
        lendingKitTabFilters: window.config.stockStatuses
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lendingKitColumns.js